import SelectBox from "devextreme-react/select-box";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { dmCauHinhSmsApi } from '../../api/sms/dm_cauhinh_sms_api';
import { useCommonContext } from '../../contexts/common';

const SelectSmsCauHinh = ({
    value,
    onValueChanged,
    showClearButton
}) => {
    const { translate } = useCommonContext();
    const [dm_cauhinhsmss, set_dm_cauhinhsmss] = useState([]);
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const [valueConfig, setValueConfig] = useState(0);

    useEffect(() => {
        (async () => {
            onValueChanged([]);
            const res = await dmCauHinhSmsApi.SelectAll();
            if (res.is_success) {
                res.data = res.data.filter(x => x.dm_coso_id == dm_coso_id && x.is_actived);
                
                set_dm_cauhinhsmss(res.data);
            } else {
                set_dm_cauhinhsmss([]);
            }
        })();
    }, []);

    const containerStyle = {
        width: '100%',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
    };

    return (
        <div
            style={containerStyle}
        >
            <SelectBox
                items={dm_cauhinhsmss}
                showSelectionControls={true}
                searchEnabled
                displayExpr={'mo_ta_sms'}
                valueExpr={'id'}
                value={valueConfig == 0 ? value : valueConfig}
                multiline={false}
                stylingMode="outlined"
                width={'100%'}
                placeholder={translate('Chọn gửi từ sms')}
                showClearButton={showClearButton}
                applyValueMode="useButtons"
                onValueChanged={(e) => {
                    onValueChanged(e.value);
                }}
            />
        </div>
    );
};

export default SelectSmsCauHinh;
